export const TRIP_ENDPOINT = `https://${process.env.NEXT_PUBLIC_TRIP_GATEWAY_DOMAIN_NAME}`;
